import clsx from "clsx";

export default function RecusedBadge({
  className = "",
}: {
  className?: string;
}) {
  return (
    <span
      className={clsx(
        "inline-block text-xs font-semibold rounded px-2 py-0.5",
        "bg-red-300 text-red-900 dark:bg-red-800 dark:text-red-300",
        className,
      )}
    >
      Recused
    </span>
  );
}
